import React, { FC } from 'react';
import { HormonePatternContent } from '../../../common/model/dto/hormone-pattern-content';
import { useTranslation } from 'react-i18next';
import OvListTableField from '../atoms/OvListTableField';
import StringUtils from '../../../common/utils/services/string-utils';
import OvListTableButtonField from '../atoms/OvListTableButtonField';
import styled from 'styled-components';
import OvButton from '../atoms/OvButton';
import { NavLink } from 'react-router-dom';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvHormonePatternContentListRowProps {
  hormonePatternContent: HormonePatternContent;
}

const OvHormonePatternContentListRow: FC<
  OvHormonePatternContentListRowProps
> = ({ hormonePatternContent }) => {
  const { t } = useTranslation();

  return (
    <>
      <OvListTableField>
        {StringUtils.displayValue(hormonePatternContent.key)}
      </OvListTableField>
      <OvListTableField>
        {StringUtils.displayValue(hormonePatternContent.health_goal)}
      </OvListTableField>
      <OvListTableField>
        {StringUtils.displayValue(hormonePatternContent.name)}
      </OvListTableField>
      <OvListTableField>
        {StringUtils.displayValue(hormonePatternContent.short_description)}
      </OvListTableField>
      <OvListTableField>
        {hormonePatternContent.number_of_times_detected}
      </OvListTableField>
      <OvListTableButtonField>
        <StyledOvButton>
          <NavLink to={`/hormone-pattern-contents/${hormonePatternContent.id}`}>
            {t('common.actions.seeDetails')}
          </NavLink>
        </StyledOvButton>
      </OvListTableButtonField>
    </>
  );
};

export default OvHormonePatternContentListRow;

const StyledOvButton = styled(OvButton)`
  && {
    border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
    padding: 0;
    margin: 0;
    background-color: ${Colours.OV_BASE};

    &:hover {
      a {
        color: ${Colours.OV_BASE};
      }
    }

    a {
      border-radius: ${Variables.borderRadius.CLINIC_DASHBOARD_LARGE};
      padding: 0.25rem 1rem;
      text-decoration: none;
      text-transform: none;
      font-weight: bold;
      font-size: 0.75rem;
      color: ${Colours.OV_WHITE};
    }
  }
`;
